export default {
  title: 'My orders',
  subtitle: 'View your active keys and past purchases.',

  // Empty state
  noOrdersTitle: 'No orders yet',
  noOrdersBody: 'When you buy your first game key, it will show up here with delivery details.',
  browseCatalog: 'Browse catalog',

  // Pending orders
  pendingOrders: 'Pending orders',
  activeCount: '{count} active',
  noPendingOrders: 'No pending orders.',
  purchasedOn: 'Purchased on {date}',
  statusDelivered: 'Delivered',
  statusProcessing: 'Processing',
  showKey: 'Show key',
  revealing: 'Revealing…',
  revealed: 'Revealed',
  keyNotReady: 'Key not ready yet — check back shortly.',
  keyNotAvailable: 'Key not available yet.',
  howToActivate: 'How to activate',

  // Activation steps — Steam
  steamStep1: 'Launch Steam and log into your account.',
  steamStep2: 'Click "Games" menu, then "Activate a Product on Steam".',
  steamStep3: 'Follow prompts and enter the key when requested.',
  // Activation steps — generic
  genericStep1: 'Open the official client / launcher.',
  genericStep2: 'Find "Activate a product" or "Redeem code".',
  genericStep3: 'Enter your key when requested.',

  // History
  orderHistory: 'Order history',
  colDate: 'Date',
  colProduct: 'Product',
  colPrice: 'Price',
  colStatus: 'Status',
  colInvoice: 'Invoice',
  download: 'Download',
  notAvailable: 'N/A',
  noPastOrders: 'No past orders yet.',
  browseTheCatalog: 'Browse the catalog',
  noPastOrdersSuffix: 'to get started.',
};
